import interceptorsLoader from './axios-interceptors-loader';
import wixAspectsInterceptor from './axios-intercept-wix-aspects';
import * as httpClientSupport from '@wix/wix-http-client-support';
import logger from '@wix/wix-debug';
var log = logger('axios-server-config');
export default (function (axios, _ref) {
  var req = _ref.req,
      adapter = _ref.adapter,
      baseURL = _ref.baseURL;

  if (!req) {
    throw new Error('Request must be provided');
  }

  var instance = axios.create({
    baseURL: baseURL || axios.defaults.baseURL,
    adapter: adapter
  });
  instance.unregisterWixInterceptors = interceptorsLoader.loadIfNeeded(instance, {
    shouldLoadInterceptors: true,
    interceptors: [wixAspectsInterceptor({
      clientSupport: clientSupport(req),
      logger: log
    })]
  });
  return instance;
});

function clientSupport(req) {
  return {
    fromResponse: httpClientSupport.fromResponse(req),
    toRequestHeaders: httpClientSupport.toRequestHeaders(req)
  };
}